import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, fetchUserDetails } from '../services/authService';  // Import the service
import '../login.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);  // Add loading state
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    const credentials = { email, password };

    // Set loading to true when the login attempt starts
    setLoading(true);

    try {
      const response = await login(credentials);

      console.log('Login Response:', response);

      if (response) {
        localStorage.setItem('jwtToken', response.token);  // Store JWT token
        localStorage.setItem('userId', response.userId);  // Store user ID
         // Step 2: Fetch user details using userId
         const userDetails = await fetchUserDetails(response.userId);
         if (userDetails) {
           localStorage.setItem('userName', userDetails.name); // Store the user's name
         } else {
           setErrorMessage('Failed to fetch user details.');
         }
        console.log('Navigating to home page');
        window.location.href = '/home';
      } else {
        setErrorMessage('Login failed. Please try again.');
      }
    } catch (error) {
      console.error('Login Error:', error);
      setErrorMessage('Login failed. Please try again.');
    } finally {
      // Set loading to false once the request finishes (either success or failure)
      setLoading(false);
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-form-container">
        <h2 className="login-heading">Login</h2>
        <form onSubmit={handleLogin} className="login-form">
          <div className="login-input-container">
            <label htmlFor="email" className="login-label">Email</label>
            <input
              type="email"
              id="email"
              className="login-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="login-input-container">
            <label htmlFor="password" className="login-label">Password</label>
            <input
              type="password"
              id="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            Login
          </button> {/* Disable button when loading */}
        </form>

        {/* Show the loading message box while the request is in progress */}
        {loading && (
          <div className="loading-overlay">
            <div className="loading-box">
              <p className="loading-text">Please wait, we are checking your credentials...</p>
            </div>
          </div>
        )}

        {errorMessage && <p className="error-message">{errorMessage}</p>}

        <p className="signup-prompt">
          Don't have an account? <a href="/auth/signup" className="signup-link">Register here</a>
        </p>

        {/* Redirect to Forgot Password Page */}
        <button
          type="button"
          onClick={() => navigate('/forgot-password')}
          className="forgot-password-button"
        >
          Forgot Password?
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
